import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/site/content";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-widest text-blue-700 mb-3">
            Owners say it best
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
            Real results, from real local businesses.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="rounded-xl border border-gray-200 bg-white p-7 hover:shadow-lg transition-all"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className="text-blue-700/20" size={32} />
              <div className="flex gap-1 mt-2 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} size={14} className="fill-blue-700 text-blue-700" />
                ))}
              </div>
              <p className="text-gray-800 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-gray-100">
                <div className="font-display font-bold text-gray-900">{t.name}</div>
                <div className="text-xs text-gray-500 mt-0.5">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
